import { GridFilterOperator } from '@mui/x-data-grid-pro';
import { LabelledEntity } from 'shared/types/commonView';
import { createContainsDirectEntityOperator } from './operatorFactories';

interface CreatedByRow {
  createdBy?: LabelledEntity | null;
}

export const createCreatedByOperator = (
  inputComponent: GridFilterOperator['InputComponent']
) =>
  createContainsDirectEntityOperator(
    inputComponent,
    (row: CreatedByRow) => row.createdBy ?? null
  );
